/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module IDENTITY CONSTANTS
 */

// Action constants
export const MODULE_NAME = "IDENTITY/";

// Actions type
export const SET_AUTHENTICATED = `${MODULE_NAME}SET_AUTHENTICATED`;
export const LOGOUT = `${MODULE_NAME}LOGOUT`;
export const GET_ME = `${MODULE_NAME}GET_ME`;
